import { render, staticRenderFns } from "./LpuAddress.vue?vue&type=template&id=852c6e80&scoped=true&"
import script from "./LpuAddress.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuAddress.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuAddress.vue?vue&type=style&index=0&id=852c6e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852c6e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('852c6e80')) {
      api.createRecord('852c6e80', component.options)
    } else {
      api.reload('852c6e80', component.options)
    }
    module.hot.accept("./LpuAddress.vue?vue&type=template&id=852c6e80&scoped=true&", function () {
      api.rerender('852c6e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuAddress.vue"
export default component.exports